export class ApplicationInfo {
  private static appName: string;

  static getAppName() {
    return ApplicationInfo.appName;
  }

  static setAppName(appName: string) {
    this.appName = appName;
  }
}
